exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (max-width:640px){.atn__wrap[data-v-7784e696]{flex-direction:column}}", ""]);

// exports
